import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { PageHeader } from '@/components/PageHeader';
import { ValidationEngine } from '@/components/ValidationEngine';
import { AdvancedValidationRules } from '@/components/AdvancedValidationRules';

const ValidationDashboard: React.FC = () => {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Advanced Validation Engine"
        description="Phase 6: Comprehensive data validation and quality control"
      />

      <Tabs defaultValue="engine" className="w-full">
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="engine">Validation Engine</TabsTrigger>
          <TabsTrigger value="rules">Rule Management</TabsTrigger>
        </TabsList>

        <TabsContent value="engine" className="space-y-6">
          <ValidationEngine />
        </TabsContent>

        <TabsContent value="rules" className="space-y-6">
          <AdvancedValidationRules />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default ValidationDashboard;